module.exports = __webpack_public_path__ + "img/_17.93737d93.png";